var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 3.5,
    width: 15,
    height: 15,
    rx: 1.23913,
    fill: "white",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0001 7V15",
    stroke: "#222222",
    strokeWidth: 0.869565
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 11C15 11 12.1473 11 11.1043 11C11.0671 11 12.4548 11 12.4166 11C10.7555 11 7 11 7 11H15Z",
    stroke: "#222222",
    strokeWidth: 0.869565
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectionIcon);
export default __webpack_public_path__ + "static/media/selection_icon.d3c77851a650d08776edc2f220cf0551.svg";
export { ForwardRef as ReactComponent };